"use client";

import HEADER_BRANDS from "@stadium/ui/src/components/brands/constants";
import ExternalButton from "@stadium/ui/src/components/button/external-button";
import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";

import defaultStyles from "@stadium/ui/src/components/brands/main.module.scss";

//This is designed solely for responsive view.

const Brands = ({ styles = defaultStyles, isNextImage = false }) => {
  const renderBrandLink = ({
    key,
    imgSrc,
    url,
    mbImgWidth,
    bannerBGClass,
    backgroundImg,
    mbBgImgHt,
  }) => (
    <ExternalButton
      href={url}
      btnStyle="no-style"
      target="_blank"
      className={`${styles.brandItem} ${bannerBGClass}`}
    >
      <div className={styles.brandItemRow}>
        <div className={styles.brandItemLogo}>
          <Multimedia
            type="image"
            src={imgSrc}
            alt={key}
            width={mbImgWidth}
            height={40}
            noBlur
            isNextImage={isNextImage}
          />
        </div>
        <div className={styles.brandItemImage}>
          <Multimedia
            type="image"
            src={backgroundImg}
            alt={key}
            width={mbImgWidth}
            height={mbBgImgHt}
            noBlur
            isNextImage={isNextImage}
          />
        </div>
      </div>
    </ExternalButton>
  );
  return (
    <>
      <div className={`${styles.webBrandItems} ${styles.brandItems}`}>
        <div className={styles.brandIteamHead}>1 Account, Many Brands</div>
      </div>
      {HEADER_BRANDS({ styles }).map((brand) => (
        <div key={`brand-${brand.name}`} className={styles.brandItemContainer}>
          {renderBrandLink(brand)}
        </div>
      ))}
    </>
  );
};

export default Brands;
